export const titleCaseFunction = (data) => data?.replace(/\w\S*/g, (val) => val.charAt(0).toUpperCase() + val.substr(1).toLowerCase());
